import { csx } from '@vtex/admin-ui'

const styles = {
  advancedContent: csx({
    gap: '$space-3',
  }),
}

export default styles
